export default () => top.location !== self.location
